// Nav bar functions
export const handleMenu = (type) => {
    let menu = document.getElementById("nav-link");
    let close = document.getElementById("close-btn");

    switch (type) {
        case "open":
            menu.style.display = "flex";
            close.style.display = "block";
            break;

        default:
            close.style.display = "none";
            menu.classList.add("nav-links-close");
            setTimeout(() => {
                menu.style.display = "none";
                menu.classList.remove("nav-links-close");
                menu.classList.add("nav-links");
            }, 1000);
            break;
    }
}

// End of nav bar functions